import {ReactNode, createContext, useContext} from "react";
import {useDisclosure} from "@chakra-ui/react";
import {useCreateRequest, CreateRequestProvider} from "./RequestCreationContext";
import {NotificationProvider, useNotification} from "./NotificationContext";
import {useAuth, AuthProvider} from "./AuthContext";
import {ChatProvider, useChat} from "./ChatContext";
import {RequestProvider, useRequest} from "./RequestContext";
import {VerificationProvider, useVerification} from "./VerificationContext";

const NavContext = createContext<ReturnType<typeof useDisclosure> | undefined>(undefined);

function NavProvider(p: {children: ReactNode}) {
    const value = useDisclosure();
    return <NavContext.Provider value={value}>
        {p.children}
    </NavContext.Provider>
}

function useNav() {
    const context = useContext(NavContext);
    if (!context) {
        throw new Error("useNav must be used within a NavProvider");
    }
    return context;
}

export {
    AuthProvider,
    ChatProvider,
    CreateRequestProvider,
    NavProvider,
    NotificationProvider,
    RequestProvider,
    VerificationProvider,
    useAuth,
    useChat,
    useCreateRequest,
    useNav,
    useNotification,
    useRequest,
    useVerification
};
